// Datos de imágenes organizadas para el sitio web
export const imageData = {
  // Imágenes para el hero carousel
  heroImages: [
    { 
      src: '/assets/hostel-front-sign-hostel-tilcara.jpg', 
      altEs: 'Entrada principal de Casa Colores con cartel colorido',
      altEn: 'Main entrance of Casa Colores with colorful sign',
      altPt: 'Entrada principal da Casa Colores com placa colorida',
      altFr: 'Entrée principale de Casa Colores avec panneau coloré'
    },
    { 
      src: '/assets/view-from-rooftop-hostel-tilcara.jpg', 
      altEs: 'Vista panorámica desde la terraza del hostel',
      altEn: 'Panoramic view from the hostel terrace',
      altPt: 'Vista panorâmica do terraço do hostel',
      altFr: 'Vue panoramique depuis la terrasse de l\'auberge'
    },
    { 
      src: '/assets/red-sofa-room-hostel-tilcara.jpg', 
      altEs: 'Sala común con sofá rojo y ambiente acogedor',
      altEn: 'Common room with red sofa and cozy atmosphere',
      altPt: 'Sala comum com sofá vermelho e ambiente aconchegante',
      altFr: 'Salon commun avec canapé rouge et ambiance chaleureuse'
    },
    { 
      src: '/assets/patio-lights-night-hostel-tilcara.jpg', 
      altEs: 'Patio iluminado por la noche con ambiente mágico',
      altEn: 'Patio lit up at night with magical atmosphere',
      altPt: 'Pátio iluminado à noite com ambiente mágico',
      altFr: 'Patio éclairé la nuit avec ambiance magique'
    }
  ],

  // Galería completa organizada por categorías
  galleryImages: [
    {
      category: 'exterior',
      images: [
        { 
          src: '/assets/hostel-front-sign-hostel-tilcara.jpg', 
          altEs: 'Acá es donde empezá todo',
          altEn: 'This is where it all begins',
          altPt: 'Aqui é onde tudo começa',
          altFr: 'C\'est ici que tout commence',
          titleEs: 'Bienvenido a Casa Colores',
          titleEn: 'Welcome to Casa Colores',
          titlePt: 'Bem-vindo à Casa Colores',
          titleFr: 'Bienvenue à Casa Colores'
        },
        { 
          src: '/assets/colorful-entrance-hostel-tilcara.jpg', 
          altEs: 'Los colores que te reciben',
          altEn: 'The colors that welcome you',
          altPt: 'As cores que te recebem',
          altFr: 'Les couleurs qui vous accueillent',
          titleEs: 'Donde empiezan las aventuras',
          titleEn: 'Where adventures begin',
          titlePt: 'Onde as aventuras começam',
          titleFr: 'Où commencent les aventures'
        },
        { 
          src: '/assets/colorful-exterior-hostel-tilcara.jpg', 
          altEs: 'Un rincón andino con historia',
          altEn: 'An Andean corner with history',
          altPt: 'Um cantinho andino com história',
          altFr: 'Un coin andin avec de l\'histoire',
          titleEs: 'Colores que alegran el alma',
          titleEn: 'Colors that brighten the soul',
          titlePt: 'Cores que alegram a alma',
          titleFr: 'Couleurs qui égayent l\'âme'
        }
      ]
    },
    {
      category: 'interior',
      images: [
        { 
          src: '/assets/red-sofa-room-hostel-tilcara.jpg', 
          altEs: 'Donde nacen las amistades',
          altEn: 'Where friendships are born',
          altPt: 'Onde nascem as amizades',
          titleEs: 'El corazón del hostel',
          titleEn: 'The heart of the hostel',
          titlePt: 'O coração do hostel'
        },
        { 
          src: '/assets/dining-room-hostel-tilcara.jpg', 
          altEs: 'Mesa que une corazones',
          altEn: 'Table that brings hearts together',
          altPt: 'Mesa que une corações',
          titleEs: 'Donde se comparten historias',
          titleEn: 'Where stories are shared',
          titlePt: 'Onde se compartilham histórias'
        },
        { 
          src: '/assets/cozy-dining-room-hostel-tilcara.jpg', 
          altEs: 'El rincón de los mates infinitos',
          altEn: 'The corner of endless mate',
          altPt: 'O cantinho dos chimarrões infinitos',
          titleEs: 'Mates y charlas infinitas',
          titleEn: 'Mate and endless conversations',
          titlePt: 'Chimarrões e conversas infinitas'
        }
      ]
    },
    {
      category: 'outdoor',
      images: [
        { 
          src: '/assets/stone-patio-benches-hostel-tilcara.jpg', 
          altEs: 'Donde el tiempo se detiene',
          altEn: 'Where time stands still',
          altPt: 'Onde o tempo para',
          titleEs: 'Espacio para compartir al aire libre',
          titleEn: 'Outdoor space to share',
          titlePt: 'Espaço para compartilhar ao ar livre'
        },
        { 
          src: '/assets/rustic-patio-hostel-tilcara.jpg', 
          altEs: 'Nuestro refugio de siempre',
          altEn: 'Our eternal refuge',
          altPt: 'Nosso refúgio de sempre',
          titleEs: 'Patio tradicional para descansar',
          titleEn: 'Traditional patio to rest',
          titlePt: 'Pátio tradicional para descansar'
        },
        { 
          src: '/assets/patio-lights-night-hostel-tilcara.jpg', 
          altEs: 'Charlas que se estiran hasta tarde',
          altEn: 'Conversations that stretch late into the night',
          altPt: 'Conversas que se estendem até tarde',
          titleEs: 'Noches mágicas en Tilcara',
          titleEn: 'Magical nights in Tilcara',
          titlePt: 'Noites mágicas em Tilcara'
        }
      ]
    },
    {
      category: 'views',
      images: [
        { 
          src: '/assets/view-from-rooftop-hostel-tilcara.jpg', 
          altEs: 'Así despertás todas las mañanas',
          altEn: 'This is how you wake up every morning',
          altPt: 'Assim você acorda todas as manhãs',
          titleEs: 'El despertar perfecto',
          titleEn: 'The perfect awakening',
          titlePt: 'O despertar perfeito'
        },
        { 
          src: '/assets/views/tilcara-mountain-landscape2.jpg', 
          altEs: 'Lo que ves desde nuestra casa',
          altEn: 'What you see from our house',
          altPt: 'O que você vê da nossa casa',
          titleEs: 'La Quebrada en todo su esplendor',
          titleEn: 'The Quebrada in all its splendor',
          titlePt: 'A Quebrada em todo seu esplendor'
        },
        { 
          src: '/assets/backyard-mountain-view-hostel-tilcara.jpg', 
          altEs: 'El fondo de casa tiene premio',
          altEn: 'The backyard comes with a prize',
          altPt: 'O fundo da casa tem prêmio',
          titleEs: 'Cerros que abrazan el alma',
          titleEn: 'Hills that embrace the soul',
          titlePt: 'Montanhas que abraçam a alma'
        }
      ]
    }
  ],

  // Imágenes específicas para secciones
  aboutImages: [
    {
      src: '/assets/red-sofa-room-hostel-tilcara.jpg',
      altEs: 'Sala común con sofá rojo',
      altEn: 'Common room with red sofa',
      altPt: 'Sala comum com sofá vermelho'
    },
    {
      src: '/assets/view-from-rooftop-hostel-tilcara.jpg',
      altEs: 'Vista de las montañas desde la terraza',
      altEn: 'Mountain view from the terrace',
      altPt: 'Vista das montanhas do terraço'
    },
    {
      src: '/assets/cozy-dining-room-hostel-tilcara.jpg',
      altEs: 'Comedor acogedor',
      altEn: 'Cozy dining room',
      altPt: 'Sala de jantar aconchegante'
    },
    {
      src: '/assets/patio-lights-night-hostel-tilcara.jpg',
      altEs: 'Patio iluminado de noche',
      altEn: 'Illuminated patio at night',
      altPt: 'Pátio iluminado à noite'
    }
  ],

  // Imágenes para la sección de experiencias
  experienceImages: {
    sharedSpaces: [
      {
        src: '/assets/stone-patio-benches-hostel-tilcara.jpg',
        altEs: 'Patio de piedra para compartir',
        altEn: 'Stone patio for sharing',
        altPt: 'Pátio de pedra para compartilhar'
      },
      {
        src: '/assets/rustic-patio-hostel-tilcara.jpg',
        altEs: 'Patio rústico con fogón y área de descanso',
        altEn: 'Rustic patio with fire pit and rest area',
        altPt: 'Pátio rústico com fogueira e área de descanso'
      }
    ],
    views: [
      {
        src: '/assets/views/tilcara-mountain-landscape5.jpg',
        altEs: 'Cerros multicolores característicos del norte argentino',
        altEn: 'Multicolored hills characteristic of northern Argentina',
        altPt: 'Montanhas multicoloridas características do norte argentino'
      },
      {
        src: '/assets/mountains-hostel-tilcara.jpg',
        altEs: 'Paisaje de montañas de Tilcara',
        altEn: 'Tilcara mountain landscape',
        altPt: 'Paisagem das montanhas de Tilcara'
      }
    ],
    nights: [
      {
        src: '/assets/patio-lights-night-hostel-tilcara.jpg',
        altEs: 'Ambiente nocturno en el patio',
        altEn: 'Night atmosphere in the patio',
        altPt: 'Ambiente noturno no pátio'
      },
      {
        src: '/assets/vegetarian-dishes-hostel-tilcara.jpg',
        altEs: 'Comida casera y saludable',
        altEn: 'Homemade and healthy food',
        altPt: 'Comida caseira e saudável'
      }
    ]
  },

  // Imagen para testimonios con galería de vistas adicionales
  testimonialsImage: {
    src: '/assets/backyard-mountain-view-hostel-tilcara.jpg',
    altEs: 'Vista de las montañas desde Casa Colores',
    altEn: 'Mountain view from Casa Colores',
    altPt: 'Vista das montanhas da Casa Colores'
  },

  // Galería de vistas adicionales para la sección de testimonios
  testimonialsViewsGallery: [
    {
      src: '/assets/views/tilcara-mountain-landscape1.jpg',
      altEs: 'Paisaje montañoso de Tilcara al amanecer',
      altEn: 'Tilcara mountain landscape at sunrise',
      altPt: 'Paisagem montanhosa de Tilcara ao amanhecer'
    },
    {
      src: '/assets/views/tilcara-mountain-landscape2.jpg',
      altEs: 'Vista panorámica de la Quebrada de Humahuaca',
      altEn: 'Panoramic view of Quebrada de Humahuaca',
      altPt: 'Vista panorâmica da Quebrada de Humahuaca'
    },
    {
      src: '/assets/views/tilcara-mountain-landscape3.jpg',
      altEs: 'Montañas coloridas de Jujuy desde Tilcara',
      altEn: 'Colorful Jujuy mountains from Tilcara',
      altPt: 'Montanhas coloridas de Jujuy desde Tilcara'
    },
    {
      src: '/assets/views/tilcara-mountain-landscape4.jpg',
      altEs: 'Atardecer dorado en las montañas de Tilcara',
      altEn: 'Golden sunset in Tilcara mountains',
      altPt: 'Por do sol dourado nas montanhas de Tilcara'
    },
    {
      src: '/assets/views/tilcara-mountain-landscape5.jpg',
      altEs: 'Cerros multicolores característicos del norte argentino',
      altEn: 'Multicolored hills characteristic of northern Argentina',
      altPt: 'Montanhas multicoloridas características do norte argentino'
    },
    {
      src: '/assets/views/tilcara-mountain-landscape6.jpg',
      altEs: 'Vista épica de la cordillera desde Casa Colores',
      altEn: 'Epic mountain range view from Casa Colores',
      altPt: 'Vista épica da cordilheira da Casa Colores'
    },
    {
      src: '/assets/views/tilcara-mountain-landscape7.jpg',
      altEs: 'Paisaje andino con cielo dramático en Tilcara',
      altEn: 'Andean landscape with dramatic sky in Tilcara',
      altPt: 'Paisagem andina com céu dramático em Tilcara'
    }
  ],

  // Imagen para ubicación
  locationImage: {
    src: '/assets/colorful-exterior-hostel-tilcara.jpg',
    altEs: 'Casa Colores desde el exterior',
    altEn: 'Casa Colores from the outside',
    altPt: 'Casa Colores vista do exterior'
  },

  // Imagen destacada final
  featuredImage: {
    src: '/assets/hostel-front-sign-hostel-tilcara.jpg',
    altEs: 'Casa Colores - Tu hogar en Tilcara',
    altEn: 'Casa Colores - Your home in Tilcara',
    altPt: 'Casa Colores - Sua casa em Tilcara'
  }
};

// Función helper para obtener el alt text según idioma
export const getAltText = (image, language) => {
  if (language === 'es') return image.altEs;
  if (language === 'en') return image.altEn;
  if (language === 'pt') return image.altPt;
  if (language === 'fr') return image.altFr;
  return image.altEs; // fallback
};

// Función helper para obtener el título según idioma
export const getTitle = (image, language) => {
  if (language === 'es') return image.titleEs;
  if (language === 'en') return image.titleEn;
  if (language === 'pt') return image.titlePt;
  if (language === 'fr') return image.titleFr;
  return image.titleEs; // fallback
};
